import { StoryEntity } from './story.entity';

export class StoryBuilderEntity {
    public initStory: StoryEntity;
    constructor(init?: Partial<StoryBuilderEntity>) {
        Object.assign(this, init);
    }
}